// removed by extract-text-webpack-plugin
module.exports = {"buildeeManagerRequestForm":"_1KJwIsOT_5pSvq8ftTGcVi","confirmMessage":"_3x4dryiWjrFgVWjNPnflzf"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/componentStyle/buildeeManagerRequest/buildeeManagerRequest.scss
// module id = 13410
// module chunks = 0